export const EMPTY_REMARKS =
  "Set payment pattern and first-tranche basis on the VM enrichment form to generate payment-terms remarks.";

// Raw option `name` (not display_name) for the "advance before milestone"
// choice on `first_tranche_payment_basis`. Both call sites (the VM live
// preview and the CM read-only card) MUST pass the raw form value to
// deriveCommercial() so the compare is stable across representations.
export const BASIS_ADVANCE_BEFORE_MILESTONE = "Advance before milestone";

export type DerivedCommercial = {
  advanceApplicable: "Yes" | "No" | "—";
  advancePercent: string;
  remarks: string;
};

function firstSplit(pattern: string): number {
  const first = pattern.split("-")[0];
  const n = Number(first);
  return Number.isFinite(n) ? n : 0;
}

export function deriveCommercial(
  basis: string | undefined,
  pattern: string | undefined,
  creditDays: string | undefined,
): DerivedCommercial {
  if (!basis || !pattern) {
    return {
      advanceApplicable: "—",
      advancePercent: "—",
      remarks: EMPTY_REMARKS,
    };
  }
  const cd = creditDays ?? "—";
  if (basis === BASIS_ADVANCE_BEFORE_MILESTONE) {
    const pct = firstSplit(pattern);
    return {
      advanceApplicable: "Yes",
      advancePercent: `${pct}%`,
      remarks: `Advance ${pct}% payable advance before milestone; balance per ${pattern} split. Credit period ${cd} days.`,
    };
  }
  return {
    advanceApplicable: "No",
    advancePercent: "0%",
    remarks: `No advance. Payment per ${pattern} split, ${basis.toLowerCase()}. Credit period ${cd} days.`,
  };
}
